import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const Goals = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper bigPaddings={true} isMargin={true} className="zkhfoundation-goals">
                <div className="zkhfoundation-goals__wrapper">
                    <div className="zkhfoundation-goals__grid">
                        <div className="zkhfoundation-goals__img">
                            <img
                                src="/images/svg/zkhfoundation/goals.svg"
                                alt="Цели"
                                loading="lazy"
                            />
                        </div>
                        <div className="zkhfoundation-goals__info">
                            <CommonTitle>Цели</CommonTitle>
                            <CommonSmallText>
                                Нашей главной целью было осовременить вид сайта, сделать
                                коммуникации проще, рассказать людям об&nbsp;основных направлениях
                                деятельности.
                            </CommonSmallText>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Goals;
